import { Directive, input } from '@angular/core';
import { type VariantProps, cva } from 'class-variance-authority';

import { classes } from '../../../utils/src';

const alertVariants = cva(
  "group/alert border-border relative grid w-full gap-0.5 rounded-lg border px-4 py-3 text-start text-sm has-[>ng-icon]:grid-cols-[auto_1fr] has-[>ng-icon]:gap-x-2.5 *:[ng-icon]:row-span-2 *:[ng-icon]:translate-y-0.5 *:[ng-icon]:text-current *:[ng-icon:not([class*='text-'])]:text-[length:--spacing(4)]",
  {
    variants: {
      variant: {
        default: 'bg-card text-card-foreground',
        destructive:
          'text-destructive bg-card *:data-[slot=alert-description]:text-destructive/90 *:[ng-icon]:text-current',
        warning:
          'border-amber-200 bg-amber-50 text-amber-900 *:data-[slot=alert-description]:text-amber-900/90 dark:text-amber-500 dark:*:data-[slot=alert-description]:text-amber-500/90 *:[ng-icon]:text-current',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type AlertVariants = VariantProps<typeof alertVariants>;

@Directive({
  selector: 'knx-alert,[knxAlert]',
  host: {
    'data-slot': 'alert',
    role: 'alert',
  },
})
export class KnxAlert {
  public readonly variant = input<AlertVariants['variant']>('default');

  constructor() {
    classes(() => alertVariants({ variant: this.variant() }));
  }
}
